import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Auth from "../views/Auth.vue";
import Certificates from "../views/Certificates.vue";
import CertificatesCreate from "../views/CertificatesCreate.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/auth",
    name: "auth",
    component: Auth
  },
  {
    path: "/certificates",
    name: "certificates",
    component: Certificates
  },
  {
    path: "/certificates/create",
    name: "certificates.create",
    component: CertificatesCreate
  },
  {
    path: "/certificates/edit/:id",
    name: "certificates.edit",
    component: CertificatesCreate
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
